'use strict';

var carouselHelper = require('~/components/carousel');
var load3dModel = require('~/components/load3dModel');
var loadVideo = require('~/components/loadVideo');
var focusHelper = require('base:components/focus');

/**
 * Retrieves the relevant pid value
 * @param {jquery} $el - DOM container for a given add to cart button
 * @return {string} - value to be used when adding product to cart
 */
function getPidValue($el) {
    var pid;

    if ($('#quickViewModal').hasClass('show') && !$('.product-set').length) {
        pid = $($el)
            .closest('.modal-content')
            .find('.product-quickview')
            .data('pid');
    } else if ($('.product-set-detail').length || $('.product-set').length) {
        pid = $($el)
            .closest('.product-detail')
            .find('.product-id')
            .text();
    } else {
        pid = $('.product-detail:not(".bundle-item")').data('pid');
    }

    return pid;
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    return $el && $('.set-items').length
        ? $($el)
            .closest('.product-detail')
            .find('.quantity-select')
        : $('.quantity-select');
}

/**
 * Retrieves the value associated with the Quantity pull-down menu
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {string} - value found in the quantity input
 */
function getQuantitySelected($el) {
    return getQuantitySelector($el).val();
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs, isQuickView) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            '[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]'
        );
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }
        if (attrValue.url && !attrValue.selected) {
            $swatchButton.attr('data-url', attrValue.url + (isQuickView ? '&isQuickView=true' : ''));
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');

        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
    });
}

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processSizeValues(attr, $productContainer, isQuickView) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find(
            '[data-attr="' + attr.id + '"] [data-attr-value="' + attrValue.value + '"]'
        );
        var $swatchButton = $attrValue.parent();

        if (attrValue.selected) {
            $swatchButton.addClass('selected');
        } else {
            $swatchButton.removeClass('selected');
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url + (isQuickView ? '&isQuickView=true' : ''));
        } else {
            $swatchButton.removeAttr('data-url');
        }

        // Disable if not selectable
        $swatchButton.removeAttr('disabled');

        if (!attrValue.selectable) {
            $swatchButton.attr('disabled', true);
        }

        if (attrValue.isOnline) {
            $swatchButton.removeClass('d-none');
        } else {
            $swatchButton.addClass('d-none');
        }

        var url = attrValue.url;
        var color = url.substring(
            url.lastIndexOf('_color=') + 7,
            url.indexOf('&')
        ).replace('%26', '&').replace('%2B', '+').replace('%25', '%').replace('%3E', '>');
        var size = attrValue.value;
        var isOrderable;
        if (typeof attrValue.inStockMapping[color] !== 'undefined') {
            isOrderable = !!attrValue.inStockMapping[color][size];
        }
        if (isOrderable) {
            $swatchButton.removeClass('swatch-not-orderable');
        } else {
            $swatchButton.addClass('swatch-not-orderable');
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer, isQuickView) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.url + (isQuickView ? '&isQuickView=true' : '')).removeAttr('disabled');

        if (!attrValue.selectable) {
            $attrValue.attr('disabled', true);
        }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs, isQuickView) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs, isQuickView);
        } else if (attr.id === 'size') {
            processSizeValues(attr, $productContainer, isQuickView);
        } else {
            processNonSwatchValues(attr, $productContainer, isQuickView);
        }
    });
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    if (response.product) {
        var updatedAvailability = response.product.productSoldWithQuoteRequest ? false : response.product.available;
        $productContainer.find('.product-availability').attr('data-available', updatedAvailability);
        $productContainer.find('.product-availability').attr('data-ready-to-order', response.product.readyToOrder);
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Updates the lens Description status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateLensDescription(response, $productContainer) {
    var showLensLabel = false;
    if (response.product.lensName && response.product.lensName !== 'No Lens Reference') {
        if (response.product.lensName && response.product.lensName.length > 0) {
            $productContainer.find('.lens-attribute-name').html(response.product.lensName);
            showLensLabel = true;
        } else {
            $productContainer.find('.lens-attribute-name').empty();
        }

        if (response.product.lensCategory && response.product.lensCategory.length > 0) {
            $productContainer.find('.lens-attribute-category').html(' - ' + response.product.lensCategory);
            showLensLabel = true;
        } else {
            $productContainer.find('.lens-attribute-category').empty();
        }

        if (response.product.lensDescription && response.product.lensDescription.length > 0) {
            $productContainer.find('.lens-attribute-description').html(response.product.lensDescription);
            showLensLabel = true;
        } else {
            $productContainer.find('.lens-attribute-description').empty();
        }
    } else {
        $productContainer.find('.lens-attribute-name').empty();
        $productContainer.find('.lens-attribute-category').empty();
        $productContainer.find('.lens-attribute-description').empty();
    }

    // eslint-disable-next-line no-unused-expressions
    if (showLensLabel) {
        $productContainer.find('.lens-attributes').removeClass('d-none');
    } else {
        $productContainer.find('.lens-attributes').addClass('d-none');
    }
}

/**
 * Updates the Manufacturer SKU in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateManufacturerSKU(response, $productContainer) {
    if (response.product.manufacturerSKU && response.product.manufacturerSKU.length > 0) {
        $productContainer.find('.manufacturer-sku').html(response.product.manufacturerSKU);
        $productContainer.find('.manufacturer-sku-section').removeClass('d-none');
    } else {
        $productContainer.find('.manufacturer-sku').empty();
        $productContainer.find('.manufacturer-sku-section').addClass('d-none');
    }
}

/**
 * Updates the Add to cart in the Product Detail Page
 * If the product is only sellable with a quote then the add to cart redirect to this page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateProductSoldWithQuoteRequest(response, $productContainer) {
    $productContainer.find('.pdp-quote-button a, .js-content-asset-quote-link').attr('href', response.product.productQuoteUrl);
    if (response.product.productSoldWithQuoteRequest) {
        $productContainer.find('.pdp-quote-button').removeClass('d-none').addClass('d-flex');
        $productContainer.find('.prices-add-to-cart-actions .pdp-checkout-button').not('.pdp-quote-button').addClass('d-none').removeClass('d-flex');
        $productContainer.find('.add-to-cart-quantities').addClass('d-none');
        $productContainer.find('.update-cart-url').parent().addClass('d-none').removeClass('d-flex');
        $productContainer.find('.pdp-reinsurance-asset').addClass('d-none');
    } else {
        $productContainer.find('.pdp-quote-button').addClass('d-none').removeClass('d-flex');
        $productContainer.find('.prices-add-to-cart-actions .pdp-checkout-button').not('.pdp-quote-button').removeClass('d-none').addClass('d-flex');
        $productContainer.find('.add-to-cart-quantities').removeClass('d-none');
        $productContainer.find('.update-cart-url').parent().removeClass('d-none').addClass('d-flex');
        $productContainer.find('.pdp-reinsurance-asset').removeClass('d-none');
    }
}

/**
 * Update promotion percentage
 * @param {Object} response response
 * @param {JQuery} $productContainer productContainer
 */
function updatePercentage(response, $productContainer) {
    var price = $productContainer.find('.prices .price > span');
    price.append('<span class="value percentage" content="' + response.product.price.list.decimalPrice + '"><span class="percentageValue">' + response.product.productSale + '%</span></span>');
}

/**
 * Updates the recommendation carousal in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateRecommendations(response, $productContainer) {
    var $recommendations = $productContainer.find('.recommendations-carousel');
    $recommendations.html(response.product.relatedRecommendations);
    if (response.product.relatedRecommendations) {
        $recommendations.removeClass('slick-initialized slick-slider');
        carouselHelper.methods.initRecommendationsCarousel($recommendations);
        $productContainer.find('.recommendations .product-reco').removeClass('d-none');
        $productContainer.find('.recommendations .product-reco').attr('aria-hidden', 'false');
    } else {
        $productContainer.find('.recommendations .product-reco').addClass('d-none');
        $productContainer.find('.recommendations .product-reco').attr('aria-hidden', 'true');
    }
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': ' + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * @typedef UpdatedOptionValue
 * @type Object
 * @property {string} id - Option value ID for look up
 * @property {string} url - Updated option value selection URL
 */

/**
 * @typedef OptionSelectionResponse
 * @type Object
 * @property {string} priceHtml - Updated price HTML code
 * @property {Object} options - Updated Options
 * @property {string} options.id - Option ID
 * @property {UpdatedOptionValue[]} options.values - Option values
 */

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} options - Ajax response options from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(options, $productContainer) {
    options.forEach(function (option) {
        var $optionEl = $productContainer.find('.product-option[data-option-id*="' + option.id + '"]');
        option.values.forEach(function (value) {
            var valueEl = $optionEl.find('option[data-value-id*="' + value.id + '"]');
            valueEl.val(value.url);
        });
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts = $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    var isMaster;

    if (response.product.isEcommerceDisabled === true) {
        $('.js-hide-on-ecom-disabled', $productContainer).addClass('hide-ecom');
        $('.js-show-on-ecom-disabled', $productContainer).removeClass('hide-ecom');
    } else {
        $('.js-hide-on-ecom-disabled', $productContainer).removeClass('hide-ecom');
        $('.js-show-on-ecom-disabled', $productContainer).addClass('hide-ecom');
    }

    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources, response.isQuickView);

        isMaster = response.product.productType === 'master';
        isVaraint = response.product.productType === 'variant';

        var hasSelectedColor = $productContainer.find('.color-value').hasClass('selected');
        var $sizeButtonsContainer = $productContainer.find('.size-buttons-wrapper');

        // handle the case when a master with size and color attributes has no attribute selected and it is displayed as a master (incorrect name, prices appear as a range)
        if (isMaster && hasSelectedColor) { // just the color is selected, the size is not
            if ($sizeButtonsContainer.hasClass('size-first-load')) { // page first load with no selected sizes
                var selectableSizesList = $sizeButtonsContainer.find('.size-attribute').not(':disabled'); // list of selectable sizes
                if (selectableSizesList.length > 0) { // selectable sizes list is not empty
                    $sizeButtonsContainer.removeClass('size-first-load'); // remove the original class added from the html when the page is loaded
                    attributeSelect($(selectableSizesList[0]).attr('data-url'), $productContainer); // select the first selevctable size
                }
            }
        }

        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item').data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item').data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update Display Name
    var productName = response.product.productName;
    $productContainer.find('.product-name').html(productName);

    // Update Display Color
    if (response.product.frameColor && response.product.frameColor.length > 0) {
        $productContainer.find('.frame-attribute-color-value').html(response.product.frameColor);
    }

    // Update carousel
    var carouselHtml = response.product.carouselHtml;
    carouselHelper.methods.createProductCarousel(carouselHtml, $productContainer);
    load3dModel.bind3dModel();
    loadVideo();

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $pricesContainer = $('.prices', $productContainer);
        if (response.product.isPriceHidden === true) {
            $pricesContainer.addClass('hide-price');
        } else {
            $pricesContainer.removeClass('hide-price');
        }
        var $priceSelector = $('.price', $pricesContainer).length
            ? $('.price', $pricesContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $('.promotions')
        .empty()
        .html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product,
            $productContainer: $productContainer
        });
    } else {
    // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global')
            .trigger('product:updateAddToCart', {
                product: response.product,
                $productContainer: $productContainer
            })
            .trigger('product:statusUpdate', response.product);
    }
    if (response.product.productSale) {
        updatePercentage(response, $productContainer);
    }
    updateLensDescription(response, $productContainer);

    updateRecommendations(response, $productContainer);
    $productContainer.find('.size-description').html(response.product.sizeDescription);

    if (response.product.pdpContentAssets) {
        let $contentAssetSection = $productContainer.find('.content-asset-section');
        if ($contentAssetSection.length) {
            $contentAssetSection.html(response.product.pdpContentAssets);
        } else {
            $productContainer.siblings('.content-asset-section').html(response.product.pdpContentAssets);
        }
    }
    if (response.product.pdpContentAssetsSeo) {
        let $contentAssetSeoSection = $productContainer.find('.content-asset-seo-section');
        if ($contentAssetSeoSection.length) {
            $contentAssetSeoSection.html(response.product.pdpContentAssetsSeo);
        } else {
            $productContainer.siblings('.content-asset-seo-section').html(response.product.pdpContentAssetsSeo);
        }
    }

    // Update Manufacturer SKU
    updateManufacturerSKU(response, $productContainer);

    updateProductSoldWithQuoteRequest(response, $productContainer);

    // Update Delivery Dates
    if (!response.product.available || !response.displayShippingDateRange) {
        $productContainer.find('.shipping-dates').addClass('d-none');
        $productContainer.find('.shipping-dates-value-container').addClass('d-none');
    } else {
        $productContainer.find('.shipping-dates').removeClass('d-none');
        $productContainer.find('.shipping-dates-value-container').removeClass('d-none');

        // Check if free delivery or not
        if (response.product.shippingDates) {
            var deliveryPrice = response.product.shippingDates.shippingCost;
            if (deliveryPrice === '0.00') {
                $productContainer.find('.free-shipping-dates').removeClass('d-none');
                $productContainer.find('.paid-shipping-dates').addClass('d-none');
            } else {
                $productContainer.find('.paid-shipping-dates').removeClass('d-none');
                $productContainer.find('.free-shipping-dates').addClass('d-none');
            }
        }
    }

    // Update attributes
    $productContainer
        .find('.main-attributes')
        .empty()
        .html(getAttributesHtml(response.product.attributes));

    if ($('.filter-by-lens-technology-list').length > 0 && $('.filter-by-lens-technology-list.no-refresh').length === 0) {
        var $tabToSelect = $('.filter-by-lens-technology-list li a[data-lenstechnology=\'' + response.product.lensTechnology.toLowerCase().replace(/\.|\s/g, '-') + '\']');
        $('.filter-by-lens-technology-list li').removeClass('active');
        $tabToSelect.parent().addClass('active');
        $('.lens-technology-description-variation').removeClass('d-none d-flex').addClass('d-none');
        var $currentSliderContainer = $('.lens-technology-description .variation-' + escapeSpecialChar(response.product.lensTechnology.toLowerCase().replace(/\.|\s/g, '-')));
        $currentSliderContainer.removeClass('d-none').addClass('d-flex');

        $('.variant-technology-image').removeClass('active');
        var $newImageToSelect = $('.lens-technology-description-variation .variant-color-attribute[data-image-variant=\'' + response.product.id + '\']:visible');
        $newImageToSelect.parent().addClass('active');

        $('.variant-technology-description').removeClass('active d-flex').addClass('d-none');
        var $newSectionToDisplay = $newImageToSelect.parents('.lens-technology-description-variation').find('.variant-technology-description[data-variant=\'' + response.product.id + '\']').first();
        $newSectionToDisplay.removeClass('d-none').addClass('active d-flex');
        var $currentSlickSlider = $currentSliderContainer.find('.lens-technology-carousel:visible');
        if (!$currentSlickSlider.hasClass('slick-initialized slick-slider')) {
            carouselHelper.methods.initLensTechnologyCarousel($currentSlickSlider);
        }
    } else {
        $('.filter-by-lens-technology-list').removeClass('no-refresh');
    }
}

/**
 * @typespec UpdatedQuantity
 * @type Object
 * @property {boolean} selected - Whether the quantity has been selected
 * @property {string} value - The number of products to purchase
 * @property {string} url - Compiled URL that specifies variation attributes, product ID, options,
 *     etc.
 */

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if (!($productContainer.parent('.bonus-product-item').length > 0)) {
        var optionsHtml = quantities
            .map(function (quantity) {
                var selected = quantity.selected ? ' selected ' : '';
                return (
                    '<option value="'
          + quantity.value
          + '"  data-url="'
          + quantity.url
          + '"'
          + selected
          + '>'
          + quantity.value
          + '</option>'
                );
            })
            .join('');
        getQuantitySelector($productContainer)
            .empty()
            .html(optionsHtml);
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect', { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.options, $productContainer);
                var productQuantities = (data.product.customquantities && data.product.customquantities.length > 0) ? data.product.customquantities : data.product.quantities;
                updateQuantities(productQuantities, $productContainer);
                $('body').trigger('product:afterAttributeSelect', { data: data, container: $productContainer });
                $.spinner().stop();
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @return {string} - The provided URL to use when adding a product to the cart
 */
function getAddToCartUrl() {
    return $('.add-to-cart-url').val();
}

/**
 * Escape String for special Characters
 * @param {*} str
 * @returns
 */
function escapeSpecialChar(str) {
    return str.replace(/\+/g, '\\+');
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    const existingModal = $('#chooseBonusProductModal');
    if (existingModal.length) existingModal.remove();

    const bonusUrl = data.bonusChoiceRuleBased ? data.showProductsUrlRuleBased : data.showProductsUrlListBased;

    const htmlString = `
    <!-- Modal -->
    <div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">
        <span class="enter-message sr-only"></span>
        <div class="modal-dialog choose-bonus-product-dialog modal-lg modal-dialog-centered"
             data-total-qty="${data.maxBonusItems}"
             data-UUID="${data.uuid}"
             data-pliUUID="${data.pliUUID}"
             data-addToCartUrl="${data.addToCartUrl}"
             data-pageStart="0"
             data-pageSize="${data.pageSize}"
             data-moreURL="${bonusUrl}"
             data-bonusChoiceRuleBased="${data.bonusChoiceRuleBased}">
            <!-- Modal content-->
            <div class="modal-content d-flex flex-column" style="height: 85cqh;">
                <div class="modal-header">
                    <span>${data.labels.selectprods}</span>
                    <button type="button" class="close pull-right" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                        <span class="sr-only"></span>
                    </button>
                </div>
                <div class="modal-body flex-grow-1 overflow-auto"></div>
                <div class="modal-footer d-none"></div>
            </div>
        </div>
    </div>`;

    $('body').append(htmlString);

    function adjustModalBodyHeight() {
        const modal = $('#chooseBonusProductModal');
        if (!modal.length) return;

        const headerHeight = modal.find('.modal-header').outerHeight() || 0;
        const footerHeight = modal.find('.modal-footer').outerHeight() || 0;
        const maxHeight = $(window).height() - headerHeight - footerHeight - 40; // optional padding
        modal.find('.modal-body').css('max-height', maxHeight + 'px');
    }

    $('#chooseBonusProductModal').on('shown.bs.modal', function () {
        if (!$('.cart-page').length) {
            $('#chooseBonusProductModal .modal-content').spinner().start();
        }
        adjustModalBodyHeight();
    });

    $(window).on('resize', adjustModalBodyHeight);

    $('#chooseBonusProductModal').modal('show');

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            const parsedHtml = parseHtml(response.renderedTemplate);
            const modal = $('#chooseBonusProductModal');
            modal.find('.modal-body').html(parsedHtml.body);
            modal.find('.modal-footer').html(parsedHtml.footer);
            modal.find('.enter-message').text(response.enterDialogMessage);
            modal.find('.modal-header .close .sr-only').text(response.closeButtonText);

            $.spinner().stop();
            modal.find('.modal-content').spinner().stop();
        },
        error: function () {
            $.spinner().stop();
            $('#chooseBonusProductModal .modal-content').spinner().stop();
            console.error('Failed to load bonus products.');
        }
    });
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
 */
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);

    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
    }
}

/**
 * Retrieves the bundle product item ID's for the Controller to replace bundle master product
 * items with their selected variants
 *
 * @return {string[]} - List of selected bundle product item ID's
 */
function getChildProducts() {
    var childProducts = [];
    $('.bundle-item').each(function () {
        childProducts.push({
            pid: $(this)
                .find('.product-id')
                .text(),
            quantity: parseInt(
                $(this)
                    .find('label.quantity')
                    .data('quantity'),
                10
            )
        });
    });

    return childProducts.length ? JSON.stringify(childProducts) : [];
}

/**
 * Retrieve product options
 *
 * @param {jQuery} $productContainer - DOM element for current product
 * @return {string} - Product options and their selected values
 */
function getOptions($productContainer) {
    var options = $productContainer
        .find('.product-option')
        .map(function () {
            var $elOption = $(this).find('.options-select');
            var urlValue = $elOption.val();
            var selectedValueId = $elOption.find('option[value="' + urlValue + '"]').data('value-id');
            return {
                optionId: $(this).data('option-id'),
                selectedValueId: selectedValueId
            };
        })
        .toArray();

    return JSON.stringify(options);
}

module.exports = {
    attributeSelect: attributeSelect,
    methods: {
        editBonusProducts: function (data) {
            chooseBonusProducts(data);
        }
    },

    focusChooseBonusProductModal: function () {
        $('body').on('shown.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal')
                .siblings()
                .attr('aria-hidden', 'true');
            $('#chooseBonusProductModal .close').focus();
        });
    },

    onClosingChooseBonusProductModal: function () {
        $('body').on('hidden.bs.modal', '#chooseBonusProductModal', function () {
            $('#chooseBonusProductModal')
                .siblings()
                .attr('aria-hidden', 'false');
        });
    },

    trapChooseBonusProductModalFocus: function () {
        $('body').on('keydown', '#chooseBonusProductModal', function (e) {
            var focusParams = {
                event: e,
                containerSelector: '#chooseBonusProductModal',
                firstElementSelector: '.close',
                lastElementSelector: '.add-bonus-products'
            };
            focusHelper.setTabNextFocus(focusParams);
        });
    },

    buttonAttribute: function () {
        $(document).on('click', '[data-attr="color"] button, [data-attr="size"] button', function (e) {
            e.preventDefault();

            if ($(this).attr('disabled')) {
                return;
            }
            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }

            attributeSelect($(this).attr('data-url'), $productContainer);
        });
    },

    selectAttribute: function () {
        $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.set-item');
            if (!$productContainer.length) {
                $productContainer = $(this).closest('.product-detail');
            }
            attributeSelect(e.currentTarget.value, $productContainer);
        });
    },

    availability: function () {
        $(document).on('change', '.quantity-select', function (e) {
            e.preventDefault();

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this)
                    .closest('.modal-content')
                    .find('.product-quickview');
            }

            if ($('.bundle-items', $productContainer).length === 0) {
                attributeSelect(
                    $(e.currentTarget)
                        .find('option:selected')
                        .data('url'),
                    $productContainer
                );
            }
        });
    },

    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;
            var $this = $(this);

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $(this).hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$(this).hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $(this)
                                .find('.product-id')
                                .text(),
                            qty: $(this)
                                .find('.quantity-select')
                                .val(),
                            options: getOptions($(this))
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = getPidValue($(this));

            var $productContainer = $(this).closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $(this)
                    .closest('.quick-view-dialog')
                    .find('.product-detail');
            }

            addToCartUrl = getAddToCartUrl();

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: getChildProducts(),
                quantity: getQuantitySelected($(this))
            };

            if (!$('.bundle-item').length) {
                form.options = getOptions($productContainer);
            }

            $(this).trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                var $rxb2cModal = $('#rxB2CAddToCartModal');
                if ($rxb2cModal.length && $('input[name="currentCartIsRX"]', $rxb2cModal).val() === 'true' && $('input[name="customerConfirmSubmit"]', $rxb2cModal).val() !== 'true') {
                    $.spinner().stop();
                    $('body').trigger('rxb2c:openconfirmationmodal', {
                        actionTarget: $this
                    });
                    return;
                }

                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        $.spinner().stop();
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    selectBonusProduct: function () {
        $(document).on('click', '.select-bonus-product', function () {
            //Remove Previously added product
            $('.selected-pid').trigger('click');

            var $choiceOfBonusProduct = $(this).parents('.choice-of-bonus-product');
            var pid = $(this).data('pid');
            var maxPids = $('.choose-bonus-product-dialog').data('total-qty');
            var submittedQty = parseInt($choiceOfBonusProduct.find('.bonus-quantity-select').val(), 10);
            var totalQty = 0;
            $.each($('#chooseBonusProductModal .selected-bonus-products .selected-pid'), function () {
                totalQty += $(this).data('qty');
            });
            totalQty += submittedQty;
            var optionID = $choiceOfBonusProduct.find('.product-option').data('option-id');
            var valueId = $choiceOfBonusProduct.find('.options-select option:selected').data('valueId');
            if (totalQty <= maxPids) {
                var selectedBonusProductHtml = ''
          + '<div class="selected-pid row" '
          + 'data-pid="'
          + pid
          + '"'
          + 'data-qty="'
          + submittedQty
          + '"'
          + 'data-optionID="'
          + (optionID || '')
          + '"'
          + 'data-option-selected-value="'
          + (valueId || '')
          + '"'
          + '>'
          + '<div class="col-sm-11 col-9 bonus-product-name" >'
          + $choiceOfBonusProduct.find('.product-name').html()
          + '</div>'
          + '<div class="col-1"><i class="fa fa-times" aria-hidden="true"></i></div>'
          + '</div>';
                $('#chooseBonusProductModal .selected-bonus-products').append(selectedBonusProductHtml);
                $('.pre-cart-products').html(totalQty);
                $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
            } else {
                $('.selected-bonus-products .bonus-summary').addClass('alert-danger');
            }
            $('.add-bonus-products').trigger('click');
        });
    },
    removeBonusProduct: function () {
        $(document).on('click', '.selected-pid', function () {
            $(this).remove();
            var $selected = $('#chooseBonusProductModal .selected-bonus-products .selected-pid');
            var count = 0;
            if ($selected.length) {
                $selected.each(function () {
                    count += parseInt($(this).data('qty'), 10);
                });
            }

            $('.pre-cart-products').html(count);
            $('.selected-bonus-products .bonus-summary').removeClass('alert-danger');
        });
    },
    enableBonusProductSelection: function () {
        $('body').on('bonusproduct:updateSelectButton', function (e, response) {
            $('button.select-bonus-product', response.$productContainer).attr(
                'disabled',
                !response.product.readyToOrder || !response.product.available
            );
            var pid = response.product.id;
            $('button.select-bonus-product', response.$productContainer).data('pid', pid);
        });
    },
    showMoreBonusProducts: function () {
        $(document).on('click', '.show-more-bonus-products', function () {
            var url = $(this).data('url');
            $('.modal-content')
                .spinner()
                .start();
            $.ajax({
                url: url,
                method: 'GET',
                success: function (html) {
                    var parsedHtml = parseHtml(html);
                    $('.modal-body').append(parsedHtml.body);
                    $('.show-more-bonus-products:first').remove();
                    $('.modal-content')
                        .spinner()
                        .stop();
                },
                error: function () {
                    $('.modal-content')
                        .spinner()
                        .stop();
                }
            });
        });
    },
    addBonusProductsToCart: function () {
        $(document).on('click', '.add-bonus-products', function () {
            var $readyToOrderBonusProducts = $('.choose-bonus-product-dialog .selected-pid');
            var queryString = '?pids=';
            var url = $('.choose-bonus-product-dialog').data('addtocarturl');
            var pidsObject = {
                bonusProducts: []
            };

            $.each($readyToOrderBonusProducts, function () {
                var qtyOption = parseInt($(this).data('qty'), 10);

                var option = null;
                if (qtyOption > 0) {
                    if ($(this).data('optionid') && $(this).data('option-selected-value')) {
                        option = {};
                        option.optionId = $(this).data('optionid');
                        option.productId = $(this).data('pid');
                        option.selectedValueId = $(this).data('option-selected-value');
                    }
                    pidsObject.bonusProducts.push({
                        pid: $(this).data('pid'),
                        qty: qtyOption,
                        options: [option]
                    });
                    pidsObject.totalQty = parseInt($('.pre-cart-products').html(), 10);
                }
            });
            queryString += JSON.stringify(pidsObject);
            queryString = queryString + '&uuid=' + $('.choose-bonus-product-dialog').data('uuid');
            queryString = queryString + '&pliuuid=' + $('.choose-bonus-product-dialog').data('pliuuid');
            $.spinner().start();
            $.ajax({
                url: url + queryString,
                method: 'POST',
                success: function (data) {
                    $.spinner().stop();
                    if (data.error) {
                        $('#chooseBonusProductModal').modal('hide');
                        if ($('.add-to-cart-messages').length === 0) {
                            $('body').append('<div class="add-to-cart-messages"></div>');
                        }
                        $('.add-to-cart-messages').append(
                            '<div class="alert alert-danger add-to-basket-alert text-center"'
                            + ' role="alert">'
                            + data.errorMessage + '</div>'
                        );
                        setTimeout(function () {
                            $('.add-to-basket-alert').remove();
                        }, 3000);
                    } else {
                        $('.configure-bonus-product-attributes').html(data);
                        $('.bonus-products-step2').removeClass('hidden-xl-down');
                        $('#chooseBonusProductModal').modal('hide');

                        $('.minicart-quantity').html(data.totalQty);
                        if ($('.cart-page').length === 0) {
                            $('body').trigger('cart:update');
                        }
                        setTimeout(function () {
                            if ($('.cart-page').length) {
                                location.reload();
                            }
                        }, 1500);
                    }
                },
                error: function () {
                    $.spinner().stop();
                }
            });
        });
    },
    getPidValue: getPidValue,
    getQuantitySelected: getQuantitySelected
};
